import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";
// import { normParam } from '@/tools'
// import Vue from 'vue'

// const M_API = API + '/pengurus'
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
const RTOKEN = "rToken";

const store = {
  namespaced: true,
  state: {
    pengurus: null,
    config: null,
    token: lc.getItem(TOKEN),
    rToken: lc.getItem(RTOKEN),
    permission: [],
    roles: [],
    meta: null,
    promiseRT: null,
    arrayOfRT: [],
    retryRefresh: true
  },
  getters: {
    pengurus(state) {
      return state.pengurus;
    },
    permission(state) {
      return state.permission;
    },
    wargaMeta(state) {
      return state.meta ? state.meta.wargas_meta : null;
    },
    roles(state) {
      return state.roles;
    },
    check(state) {
      return state.token;
    },
    token(state) {
      return state.token;
    },
    rToken(state) {
      return state.rToken;
    },
    promiseRT(state) {
      return state.promiseRT;
    },
    arrayOfRT(state) {
      return state.arrayOfRT;
    },
    retryRefresh(state) {
      return state.retryRefresh;
    }
  },
  actions: {
    // eslint-disable-next-line
    get({}, { params }) {
      return axios
        .get(`${M_API}/jabatan${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getJabatan({}, { params }) {
      return axios
        .get(`${M_API}/jabatan${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    downloadPengurusZIP(_, { url, params }) {
      return axios
        .get(`${API}/api/${url}${normParam(params)}`)
        .then(res => {
          window.open(res.data.url_zip, "_blank");
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKandidat({}, { params }) {
      return axios
        .get(`${M_API}/jabatan_kandidat${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getHubunganKeluarga({}, { params }) {
      return axios
        .get(`${M_API}/master?master=status_hubungan_keluarga`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getProvinsi({}, { params }) {
      return axios
        .get(`${M_API}/master?master=propinsi`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKota({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=kota&propinsi_id=${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKecamatan({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=kecamatan&kota_id=${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelurahan({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=kelurahan&kecamatan_id=${id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPekerjaan({}, { id, params }) {
      return axios
        .get(`${M_API}/master?master=status_pekerjaan`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    generateNomor({}, obj) {
      return axios
        .post(`${M_API}/pengurus/${obj.id}/generate_nomer_anggota`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    setsipol(_, { obj, value }) {
      obj.is_sipol = value;
      return axios
        .put(`${M_API}/pengurus/${obj.id}/setsipol`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    generateNomorMasal({}, obj) {
      return axios
        .post(`${M_API}/warga_generate_nomer_anggota_all`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    form({}, obj) {
      return axios
        .post(`${M_API}/jabatan`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/pengurus/${item.id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    dropPengurus(_, { wilayah_id, item }) {
      var body = {
        wilayah_id: wilayah_id,
        jabatan_id: item.pejabat.jabatan_id
      };
      return axios.post(`${M_API}/jabatan_hapus`, body).then(res => {
        return res.data;
      });
    }
  }
};

export default store;
